import React, { Component } from 'react';
//import isLoading from '../images/2053-loading.gif';
import isLoading from '../images/7210-loading.gif';
import isLoadingBlack from '../images/2053-loading-black.gif';


export default class IsLoadingBar extends Component {
    constructor(props){
        super(props);

        this.state = {
            alttext : this.props.alttext,
            customWording: this.props.customWording,
            darkmode: false
        };
    }

    componentDidMount(){
        if(localStorage.getItem("darkmode") !== null){
              this.setState({
                darkmode : true
              });
          } 
    }

    componentDidUpdate(prevProps){
        if(this.props.alttext !== prevProps.alttext){
            this.setState({
                alttext : this.props.alttext,
                customWording: this.props.customWording,
            });
        }
    }

    render(){
        return (
            <div className="w-100 d-flex flex-column">
                {this.state.darkmode ?
                <img className="loading mx-auto" src={isLoadingBlack} style={{filter: "opacity(0.5)", width: "30%"}} alt={this.state.alttext} /> 
                :
                <img className="loading mx-auto" src={isLoading} style={{filter: "opacity(0.5)", width: "30%"}} alt={this.state.alttext} /> 
                }
                
                <h6 className="mx-auto" style={{transform: "translate(0px, -40px)", color: "#9fc5ff"}}>Loading</h6>
                {(this.state.customWording !== undefined && this.state.customWording !== '') && (
                    <h6 className="mx-auto" style={{transform: "translate(0px, -40px)", color: "#9fc5ff"}}>{this.state.customWording}</h6>
                )}
            </div>
        );
    }
}